import ProjectsDashboardAppConfig from './projects/ProjectsDashboardAppConfig';

const dashboardsConfigs = [ProjectsDashboardAppConfig];

export default dashboardsConfigs;
